import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { ChartComponent, ChartType, GaugeInputs } from '@charts';
import { TranslocoDirective } from '@jsverse/transloco';
import { ChartHeader } from '@charts';
import { ChartCardComponent } from '../../chart-card/chart-card.component';
import { TransformerLegendComponent } from '../../transformer-phases-legend/transformer-phases-legend.component';
import { TransformerPhasesLegend } from '../../../../models/infraestructure.models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ChartCardComponent,
    ChartComponent,
    TransformerLegendComponent,
    TranslocoDirective,
    ChartHeader,
  ],
  selector: 'ui-rsabt-max-intensity-chart',
  template: `
    <ng-container *transloco="let t">
      <ui-chart-card class="h-full">
        <div class="flex flex-col justify-between h-full w-full">
          <chart-header
            [title]="t('CHARTS.INTENSITY.TITLE')"
            [subtitle]="t('CHARTS.INTENSITY.SUBTITLE')"
          />
          <chart
            class="mx-auto max-w-64"
            [type]="chartType()"
            [typeInputs]="gaugeInputs()"
          />
          <ui-transformer-phases-legend
            [legend]="transformerPhasesLegend()"
          />
        </div>
      </ui-chart-card>
    </ng-container>
  `,
})
export class RsabtMaxIntensityChartComponent {
  gaugeInputs = input.required<GaugeInputs>();
  transformerPhasesLegend = input.required<TransformerPhasesLegend[]>();

  chartType = signal<ChartType>('gauge');
}
